module.exports = __webpack_public_path__ + "static/media/hockey-mask.e9d5993f.svg";